import React, { useState, useEffect } from 'react';
import * as Progress from 'react-native-progress';
import { StyleSheet, View, TouchableOpacity } from 'react-native';
import {loadStripe} from '@stripe/stripe-js';
import { config } from '../../../config';
import UtilitiesController from '../../controllers/utilitiesController';
import AuthController from '../../controllers/authController';
import {useStripe, PaymentRequestButtonElement, Elements, useElements} from '@stripe/react-stripe-js';
import AsyncStorage from '@react-native-async-storage/async-storage';

const CheckoutForm = ({coupon, price, period, onSubscriptionCompleted}) => {
    if(typeof price === 'string') {
      price = parseFloat(price)
    }

    const stripe = useStripe();
    let [paymentRequest, setPaymentRequest] = useState(null);
    let [pay_coupon, setPayCoupon] = useState(coupon);
    let [pay_amount, setPayAmount] = useState(price);
    let [pay_period, setPayPeriod] = useState(period);


    useEffect(() => {
        async function fetchMyAPI() {
          let client_secret_response = await AuthController.getPaymentIntent({amount: price * 100});

          await AsyncStorage.setItem('clientSecret', client_secret_response.client_secret)
          await AsyncStorage.setItem('payment_intent', client_secret_response.payment_intent)
          await AsyncStorage.removeItem('submitting');
        }

        fetchMyAPI()
    }, [price]);

    // Initial pay sheet setup
    useEffect(() => {

      let label = period === 'year' ? "DodoVet Yearly Subscription" : (period === 'month' ? `DodoVet Monthly Subscription. ${coupon ? coupon.display_message : ''}` : "DodoVet Six Month Subscription");

      if (stripe) {
        let amount = coupon ? 0 : price * 100;

        amount = Math.round(amount);

        paymentRequest = stripe.paymentRequest({
          country: 'US',
          currency: 'usd',
          total: {
            label,
            amount
          },
          requestPayerName: true,
          requestPayerEmail: true,
        });

        // Check the availability of the Payment Request API.
        paymentRequest.canMakePayment().then(result => {
          if (result) {
            setPaymentRequest(paymentRequest);
          }
        });

        if(paymentRequest) {
          paymentRequest.on('paymentmethod', async (ev) => {
            let submitting =  await AsyncStorage.getItem('submitting');

            if(!submitting) {
              console.log('starting subscribe');
              await AsyncStorage.setItem('submitting', 'true');

              const payment_method_id = ev.paymentMethod.id;

              let partner_id = await AsyncStorage.getItem('partner_id');

              let client_secret = await AsyncStorage.getItem('clientSecret');

              let coupon = await localStorage.getItem('coupon');
              if(coupon) coupon = JSON.parse(coupon);

              let period = await localStorage.getItem('period');

                let subscription_response = await AuthController.createPaymentIntentSubscription({partner_id, period, payment_method_id, coupon: coupon ? coupon.promo_code : null});

                console.log('subscription_response', subscription_response)

                if(!subscription_response.success) {
                  console.log('in not success')

                  await AsyncStorage.removeItem('submitting');

                  await AsyncStorage.setItem('payment_status', "false");
                  ev.complete('fail');
                } else {

                  // Report to the browser that the confirmation was successful, prompting
                  // it to close the browser payment method collection interface.
                  ev.complete('success');
                  onSubscriptionCompleted();
                  await AsyncStorage.removeItem('submitting');
                  await AsyncStorage.setItem('payment_status', "true");
                  /* // Let Stripe.js handle the rest of the payment flow.
                  const {error} = await stripe.confirmCardPayment(subscription_response.client_secret);
                  if (error) {
                    // The payment failed -- ask your customer for a new payment method.
                  } else {
                    // The payment has succeeded.
                    await AsyncStorage.removeItem('submitting');
                    await AsyncStorage.setItem('payment_status', "true");
                    onSubscriptionCompleted();
                  } */
              }

            } else {
              let payment_status = await AsyncStorage.getItem('payment_status');
              console.log('in repeat', payment_status)
              return payment_status === 'true' ? ev.complete('success') : ev.complete('fail');
            }
          });
        }
      }
    }, [stripe]);

    // Update payment amount on any change
    useEffect(() => {
      setPayCoupon(coupon);
      setPayAmount(price);
      setPayPeriod(period);

      async function setStorage() {
        if(coupon) {
          await localStorage.setItem('coupon', JSON.stringify(coupon));
        } else {
          await localStorage.removeItem('coupon');
        }

        await localStorage.setItem('period', period);
      }
      setStorage();

      if (paymentRequest) {
        let label = period === 'year' ? "DodoVet Yearly Subscription" : (period === 'month' ? `DodoVet Monthly Subscription. ${coupon ? coupon.display_message : ''}` : "DodoVet Six Month Subscription");

        let amount = coupon ? 0 : price * 100;

        amount = Math.round(amount);

        paymentRequest.update({
          total: {
            label,
            amount: Number(amount)
          }
        });
      }
    }, [paymentRequest, price, coupon, period]);

    if (paymentRequest) {
      const options = {
        paymentRequest,
        style: {
          paymentRequestButton: {
            type: 'default',
            // One of 'default', 'book', 'buy', or 'donate'
            // Defaults to 'default'

            theme: 'dark',
            // One of 'dark', 'light', or 'light-outline'
            // Defaults to 'dark'

            height: '50px',
            // Defaults to '40px'. The width is always '100%'.
          },
        }
      }

      return <View style={{ alignItems: 'center' }}>
        <View style={{ width: 335 }} ><PaymentRequestButtonElement options={options} /></View>
      </View>
    } else {
      return <View></View>;
  }

}

const ApplePayComponent = ({price, period, onSubscriptionCompleted, coupon}) => {
    const [stripePromise, setStripePromise] = useState(() => loadStripe(config.STRIPE_PK))

    const [subsciption_price, setSubscriptionPrice] = useState(price)

    useEffect(()=>{
      console.log('price changing', price)
      if(typeof price === 'string') {
        setSubscriptionPrice(parseFloat(price))
      } else {
        setSubscriptionPrice(price)
      }

    }, [price])

	return (
        <Elements stripe={stripePromise}>
            <CheckoutForm price={subsciption_price} period={period} onSubscriptionCompleted={onSubscriptionCompleted} coupon={coupon} />
        </Elements>
	);
};

export default ApplePayComponent;
